/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as SettingsTokensRouteImport } from './routes/settings.tokens'
import { Route as SettingsThemeRouteImport } from './routes/settings.theme'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as OrgsOrgSlugRouteImport } from './routes/orgs.$orgSlug'
import { Route as OrgsOrgSlugIndexRouteImport } from './routes/orgs.$orgSlug.index'
import { Route as OrgsOrgSlugProjectsProjectIdRouteImport } from './routes/orgs.$orgSlug.projects.$projectId'
import { Route as OrgsOrgSlugAdminProjectsRouteImport } from './routes/orgs.$orgSlug.admin.projects'
import { Route as OrgsOrgSlugAdminMembersRouteImport } from './routes/orgs.$orgSlug.admin.members'
import { Route as OrgsOrgSlugAdminInvitesRouteImport } from './routes/orgs.$orgSlug.admin.invites'
import { Route as OrgsOrgSlugProjectsProjectIdIndexRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.index'
import { Route as OrgsOrgSlugProjectsProjectIdTimelineRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.timeline'
import { Route as OrgsOrgSlugProjectsProjectIdShareLinksRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.share-links'
import { Route as OrgsOrgSlugProjectsProjectIdReviewSessionsRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.review-sessions'
import { Route as OrgsOrgSlugProjectsProjectIdPlaylistsRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.playlists'
import { Route as OrgsOrgSlugProjectsProjectIdDashboardRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.dashboard'
import { Route as OrgsOrgSlugProjectsProjectIdComplianceRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.compliance'
import { Route as OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.review-sessions.index'
import { Route as OrgsOrgSlugProjectsProjectIdShotsShotIdRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.shots.$shotId'
import { Route as OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.settings.task-types'
import { Route as OrgsOrgSlugProjectsProjectIdSettingsStatusesRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.settings.statuses'
import { Route as OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.review-sessions.$sessionId'
import { Route as OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.shots.$shotId.index'
import { Route as OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRouteImport } from './routes/orgs.$orgSlug.projects.$projectId.shots.$shotId.lineage.$generationId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/settings/tokens',
  path: '/settings/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsThemeRoute = SettingsThemeRouteImport.update({
  id: '/settings/theme',
  path: '/settings/theme',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgsOrgSlugRoute = OrgsOrgSlugRouteImport.update({
  id: '/orgs/$orgSlug',
  path: '/orgs/$orgSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgsOrgSlugIndexRoute = OrgsOrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgsOrgSlugRoute,
} as any)
const OrgsOrgSlugProjectsProjectIdRoute =
  OrgsOrgSlugProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => OrgsOrgSlugRoute,
  } as any)
const OrgsOrgSlugAdminProjectsRoute =
  OrgsOrgSlugAdminProjectsRouteImport.update({
    id: '/admin/projects',
    path: '/admin/projects',
    getParentRoute: () => OrgsOrgSlugRoute,
  } as any)
const OrgsOrgSlugAdminMembersRoute = OrgsOrgSlugAdminMembersRouteImport.update({
  id: '/admin/members',
  path: '/admin/members',
  getParentRoute: () => OrgsOrgSlugRoute,
} as any)
const OrgsOrgSlugAdminInvitesRoute = OrgsOrgSlugAdminInvitesRouteImport.update({
  id: '/admin/invites',
  path: '/admin/invites',
  getParentRoute: () => OrgsOrgSlugRoute,
} as any)
const OrgsOrgSlugProjectsProjectIdIndexRoute =
  OrgsOrgSlugProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdTimelineRoute =
  OrgsOrgSlugProjectsProjectIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdShareLinksRoute =
  OrgsOrgSlugProjectsProjectIdShareLinksRouteImport.update({
    id: '/share-links',
    path: '/share-links',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdReviewSessionsRoute =
  OrgsOrgSlugProjectsProjectIdReviewSessionsRouteImport.update({
    id: '/review-sessions',
    path: '/review-sessions',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdPlaylistsRoute =
  OrgsOrgSlugProjectsProjectIdPlaylistsRouteImport.update({
    id: '/playlists',
    path: '/playlists',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdDashboardRoute =
  OrgsOrgSlugProjectsProjectIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdComplianceRoute =
  OrgsOrgSlugProjectsProjectIdComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute =
  OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdReviewSessionsRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdShotsShotIdRoute =
  OrgsOrgSlugProjectsProjectIdShotsShotIdRouteImport.update({
    id: '/shots/$shotId',
    path: '/shots/$shotId',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute =
  OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRouteImport.update({
    id: '/settings/task-types',
    path: '/settings/task-types',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute =
  OrgsOrgSlugProjectsProjectIdSettingsStatusesRouteImport.update({
    id: '/settings/statuses',
    path: '/settings/statuses',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute =
  OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdReviewSessionsRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute =
  OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdShotsShotIdRoute,
  } as any)
const OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute =
  OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRouteImport.update({
    id: '/lineage/$generationId',
    path: '/lineage/$generationId',
    getParentRoute: () => OrgsOrgSlugProjectsProjectIdShotsShotIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/orgs/$orgSlug': typeof OrgsOrgSlugRouteWithChildren
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/theme': typeof SettingsThemeRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/share/$token': typeof ShareTokenRoute
  '/orgs/$orgSlug/': typeof OrgsOrgSlugIndexRoute
  '/orgs/$orgSlug/admin/invites': typeof OrgsOrgSlugAdminInvitesRoute
  '/orgs/$orgSlug/admin/members': typeof OrgsOrgSlugAdminMembersRoute
  '/orgs/$orgSlug/admin/projects': typeof OrgsOrgSlugAdminProjectsRoute
  '/orgs/$orgSlug/projects/$projectId': typeof OrgsOrgSlugProjectsProjectIdRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/compliance': typeof OrgsOrgSlugProjectsProjectIdComplianceRoute
  '/orgs/$orgSlug/projects/$projectId/dashboard': typeof OrgsOrgSlugProjectsProjectIdDashboardRoute
  '/orgs/$orgSlug/projects/$projectId/playlists': typeof OrgsOrgSlugProjectsProjectIdPlaylistsRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/share-links': typeof OrgsOrgSlugProjectsProjectIdShareLinksRoute
  '/orgs/$orgSlug/projects/$projectId/timeline': typeof OrgsOrgSlugProjectsProjectIdTimelineRoute
  '/orgs/$orgSlug/projects/$projectId/': typeof OrgsOrgSlugProjectsProjectIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute
  '/orgs/$orgSlug/projects/$projectId/settings/statuses': typeof OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute
  '/orgs/$orgSlug/projects/$projectId/settings/task-types': typeof OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/review-sessions/': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/theme': typeof SettingsThemeRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/share/$token': typeof ShareTokenRoute
  '/orgs/$orgSlug': typeof OrgsOrgSlugIndexRoute
  '/orgs/$orgSlug/admin/invites': typeof OrgsOrgSlugAdminInvitesRoute
  '/orgs/$orgSlug/admin/members': typeof OrgsOrgSlugAdminMembersRoute
  '/orgs/$orgSlug/admin/projects': typeof OrgsOrgSlugAdminProjectsRoute
  '/orgs/$orgSlug/projects/$projectId/compliance': typeof OrgsOrgSlugProjectsProjectIdComplianceRoute
  '/orgs/$orgSlug/projects/$projectId/dashboard': typeof OrgsOrgSlugProjectsProjectIdDashboardRoute
  '/orgs/$orgSlug/projects/$projectId/playlists': typeof OrgsOrgSlugProjectsProjectIdPlaylistsRoute
  '/orgs/$orgSlug/projects/$projectId/share-links': typeof OrgsOrgSlugProjectsProjectIdShareLinksRoute
  '/orgs/$orgSlug/projects/$projectId/timeline': typeof OrgsOrgSlugProjectsProjectIdTimelineRoute
  '/orgs/$orgSlug/projects/$projectId': typeof OrgsOrgSlugProjectsProjectIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute
  '/orgs/$orgSlug/projects/$projectId/settings/statuses': typeof OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute
  '/orgs/$orgSlug/projects/$projectId/settings/task-types': typeof OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/orgs/$orgSlug': typeof OrgsOrgSlugRouteWithChildren
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/theme': typeof SettingsThemeRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/share/$token': typeof ShareTokenRoute
  '/orgs/$orgSlug/': typeof OrgsOrgSlugIndexRoute
  '/orgs/$orgSlug/admin/invites': typeof OrgsOrgSlugAdminInvitesRoute
  '/orgs/$orgSlug/admin/members': typeof OrgsOrgSlugAdminMembersRoute
  '/orgs/$orgSlug/admin/projects': typeof OrgsOrgSlugAdminProjectsRoute
  '/orgs/$orgSlug/projects/$projectId': typeof OrgsOrgSlugProjectsProjectIdRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/compliance': typeof OrgsOrgSlugProjectsProjectIdComplianceRoute
  '/orgs/$orgSlug/projects/$projectId/dashboard': typeof OrgsOrgSlugProjectsProjectIdDashboardRoute
  '/orgs/$orgSlug/projects/$projectId/playlists': typeof OrgsOrgSlugProjectsProjectIdPlaylistsRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/share-links': typeof OrgsOrgSlugProjectsProjectIdShareLinksRoute
  '/orgs/$orgSlug/projects/$projectId/timeline': typeof OrgsOrgSlugProjectsProjectIdTimelineRoute
  '/orgs/$orgSlug/projects/$projectId/': typeof OrgsOrgSlugProjectsProjectIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute
  '/orgs/$orgSlug/projects/$projectId/settings/statuses': typeof OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute
  '/orgs/$orgSlug/projects/$projectId/settings/task-types': typeof OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRouteWithChildren
  '/orgs/$orgSlug/projects/$projectId/review-sessions/': typeof OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute
  '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId': typeof OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/orgs/$orgSlug'
    | '/settings/profile'
    | '/settings/theme'
    | '/settings/tokens'
    | '/share/$token'
    | '/orgs/$orgSlug/'
    | '/orgs/$orgSlug/admin/invites'
    | '/orgs/$orgSlug/admin/members'
    | '/orgs/$orgSlug/admin/projects'
    | '/orgs/$orgSlug/projects/$projectId'
    | '/orgs/$orgSlug/projects/$projectId/compliance'
    | '/orgs/$orgSlug/projects/$projectId/dashboard'
    | '/orgs/$orgSlug/projects/$projectId/playlists'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions'
    | '/orgs/$orgSlug/projects/$projectId/share-links'
    | '/orgs/$orgSlug/projects/$projectId/timeline'
    | '/orgs/$orgSlug/projects/$projectId/'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId'
    | '/orgs/$orgSlug/projects/$projectId/settings/statuses'
    | '/orgs/$orgSlug/projects/$projectId/settings/task-types'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions/'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId/'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/settings/profile'
    | '/settings/theme'
    | '/settings/tokens'
    | '/share/$token'
    | '/orgs/$orgSlug'
    | '/orgs/$orgSlug/admin/invites'
    | '/orgs/$orgSlug/admin/members'
    | '/orgs/$orgSlug/admin/projects'
    | '/orgs/$orgSlug/projects/$projectId/compliance'
    | '/orgs/$orgSlug/projects/$projectId/dashboard'
    | '/orgs/$orgSlug/projects/$projectId/playlists'
    | '/orgs/$orgSlug/projects/$projectId/share-links'
    | '/orgs/$orgSlug/projects/$projectId/timeline'
    | '/orgs/$orgSlug/projects/$projectId'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId'
    | '/orgs/$orgSlug/projects/$projectId/settings/statuses'
    | '/orgs/$orgSlug/projects/$projectId/settings/task-types'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/orgs/$orgSlug'
    | '/settings/profile'
    | '/settings/theme'
    | '/settings/tokens'
    | '/share/$token'
    | '/orgs/$orgSlug/'
    | '/orgs/$orgSlug/admin/invites'
    | '/orgs/$orgSlug/admin/members'
    | '/orgs/$orgSlug/admin/projects'
    | '/orgs/$orgSlug/projects/$projectId'
    | '/orgs/$orgSlug/projects/$projectId/compliance'
    | '/orgs/$orgSlug/projects/$projectId/dashboard'
    | '/orgs/$orgSlug/projects/$projectId/playlists'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions'
    | '/orgs/$orgSlug/projects/$projectId/share-links'
    | '/orgs/$orgSlug/projects/$projectId/timeline'
    | '/orgs/$orgSlug/projects/$projectId/'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId'
    | '/orgs/$orgSlug/projects/$projectId/settings/statuses'
    | '/orgs/$orgSlug/projects/$projectId/settings/task-types'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId'
    | '/orgs/$orgSlug/projects/$projectId/review-sessions/'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId/'
    | '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  OrgsOrgSlugRoute: typeof OrgsOrgSlugRouteWithChildren
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsThemeRoute: typeof SettingsThemeRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tokens': {
      id: '/settings/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/theme': {
      id: '/settings/theme'
      path: '/settings/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof SettingsThemeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orgs/$orgSlug': {
      id: '/orgs/$orgSlug'
      path: '/orgs/$orgSlug'
      fullPath: '/orgs/$orgSlug'
      preLoaderRoute: typeof OrgsOrgSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orgs/$orgSlug/': {
      id: '/orgs/$orgSlug/'
      path: '/'
      fullPath: '/orgs/$orgSlug/'
      preLoaderRoute: typeof OrgsOrgSlugIndexRouteImport
      parentRoute: typeof OrgsOrgSlugRoute
    }
    '/orgs/$orgSlug/projects/$projectId': {
      id: '/orgs/$orgSlug/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/orgs/$orgSlug/projects/$projectId'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdRouteImport
      parentRoute: typeof OrgsOrgSlugRoute
    }
    '/orgs/$orgSlug/admin/projects': {
      id: '/orgs/$orgSlug/admin/projects'
      path: '/admin/projects'
      fullPath: '/orgs/$orgSlug/admin/projects'
      preLoaderRoute: typeof OrgsOrgSlugAdminProjectsRouteImport
      parentRoute: typeof OrgsOrgSlugRoute
    }
    '/orgs/$orgSlug/admin/members': {
      id: '/orgs/$orgSlug/admin/members'
      path: '/admin/members'
      fullPath: '/orgs/$orgSlug/admin/members'
      preLoaderRoute: typeof OrgsOrgSlugAdminMembersRouteImport
      parentRoute: typeof OrgsOrgSlugRoute
    }
    '/orgs/$orgSlug/admin/invites': {
      id: '/orgs/$orgSlug/admin/invites'
      path: '/admin/invites'
      fullPath: '/orgs/$orgSlug/admin/invites'
      preLoaderRoute: typeof OrgsOrgSlugAdminInvitesRouteImport
      parentRoute: typeof OrgsOrgSlugRoute
    }
    '/orgs/$orgSlug/projects/$projectId/': {
      id: '/orgs/$orgSlug/projects/$projectId/'
      path: '/'
      fullPath: '/orgs/$orgSlug/projects/$projectId/'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdIndexRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/timeline': {
      id: '/orgs/$orgSlug/projects/$projectId/timeline'
      path: '/timeline'
      fullPath: '/orgs/$orgSlug/projects/$projectId/timeline'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdTimelineRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/share-links': {
      id: '/orgs/$orgSlug/projects/$projectId/share-links'
      path: '/share-links'
      fullPath: '/orgs/$orgSlug/projects/$projectId/share-links'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdShareLinksRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/review-sessions': {
      id: '/orgs/$orgSlug/projects/$projectId/review-sessions'
      path: '/review-sessions'
      fullPath: '/orgs/$orgSlug/projects/$projectId/review-sessions'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/playlists': {
      id: '/orgs/$orgSlug/projects/$projectId/playlists'
      path: '/playlists'
      fullPath: '/orgs/$orgSlug/projects/$projectId/playlists'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdPlaylistsRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/dashboard': {
      id: '/orgs/$orgSlug/projects/$projectId/dashboard'
      path: '/dashboard'
      fullPath: '/orgs/$orgSlug/projects/$projectId/dashboard'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdDashboardRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/compliance': {
      id: '/orgs/$orgSlug/projects/$projectId/compliance'
      path: '/compliance'
      fullPath: '/orgs/$orgSlug/projects/$projectId/compliance'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdComplianceRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/review-sessions/': {
      id: '/orgs/$orgSlug/projects/$projectId/review-sessions/'
      path: '/'
      fullPath: '/orgs/$orgSlug/projects/$projectId/review-sessions/'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRoute
    }
    '/orgs/$orgSlug/projects/$projectId/shots/$shotId': {
      id: '/orgs/$orgSlug/projects/$projectId/shots/$shotId'
      path: '/shots/$shotId'
      fullPath: '/orgs/$orgSlug/projects/$projectId/shots/$shotId'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/settings/task-types': {
      id: '/orgs/$orgSlug/projects/$projectId/settings/task-types'
      path: '/settings/task-types'
      fullPath: '/orgs/$orgSlug/projects/$projectId/settings/task-types'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/settings/statuses': {
      id: '/orgs/$orgSlug/projects/$projectId/settings/statuses'
      path: '/settings/statuses'
      fullPath: '/orgs/$orgSlug/projects/$projectId/settings/statuses'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdSettingsStatusesRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId': {
      id: '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/orgs/$orgSlug/projects/$projectId/review-sessions/$sessionId'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRoute
    }
    '/orgs/$orgSlug/projects/$projectId/shots/$shotId/': {
      id: '/orgs/$orgSlug/projects/$projectId/shots/$shotId/'
      path: '/'
      fullPath: '/orgs/$orgSlug/projects/$projectId/shots/$shotId/'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRoute
    }
    '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId': {
      id: '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId'
      path: '/lineage/$generationId'
      fullPath: '/orgs/$orgSlug/projects/$projectId/shots/$shotId/lineage/$generationId'
      preLoaderRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRouteImport
      parentRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRoute
    }
  }
}

interface OrgsOrgSlugProjectsProjectIdReviewSessionsRouteChildren {
  OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute
  OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute
}

const OrgsOrgSlugProjectsProjectIdReviewSessionsRouteChildren: OrgsOrgSlugProjectsProjectIdReviewSessionsRouteChildren =
  {
    OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute:
      OrgsOrgSlugProjectsProjectIdReviewSessionsSessionIdRoute,
    OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute:
      OrgsOrgSlugProjectsProjectIdReviewSessionsIndexRoute,
  }

const OrgsOrgSlugProjectsProjectIdReviewSessionsRouteWithChildren =
  OrgsOrgSlugProjectsProjectIdReviewSessionsRoute._addFileChildren(
    OrgsOrgSlugProjectsProjectIdReviewSessionsRouteChildren,
  )

interface OrgsOrgSlugProjectsProjectIdShotsShotIdRouteChildren {
  OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute
  OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute
}

const OrgsOrgSlugProjectsProjectIdShotsShotIdRouteChildren: OrgsOrgSlugProjectsProjectIdShotsShotIdRouteChildren =
  {
    OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute:
      OrgsOrgSlugProjectsProjectIdShotsShotIdIndexRoute,
    OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute:
      OrgsOrgSlugProjectsProjectIdShotsShotIdLineageGenerationIdRoute,
  }

const OrgsOrgSlugProjectsProjectIdShotsShotIdRouteWithChildren =
  OrgsOrgSlugProjectsProjectIdShotsShotIdRoute._addFileChildren(
    OrgsOrgSlugProjectsProjectIdShotsShotIdRouteChildren,
  )

interface OrgsOrgSlugProjectsProjectIdRouteChildren {
  OrgsOrgSlugProjectsProjectIdComplianceRoute: typeof OrgsOrgSlugProjectsProjectIdComplianceRoute
  OrgsOrgSlugProjectsProjectIdDashboardRoute: typeof OrgsOrgSlugProjectsProjectIdDashboardRoute
  OrgsOrgSlugProjectsProjectIdPlaylistsRoute: typeof OrgsOrgSlugProjectsProjectIdPlaylistsRoute
  OrgsOrgSlugProjectsProjectIdReviewSessionsRoute: typeof OrgsOrgSlugProjectsProjectIdReviewSessionsRouteWithChildren
  OrgsOrgSlugProjectsProjectIdShareLinksRoute: typeof OrgsOrgSlugProjectsProjectIdShareLinksRoute
  OrgsOrgSlugProjectsProjectIdTimelineRoute: typeof OrgsOrgSlugProjectsProjectIdTimelineRoute
  OrgsOrgSlugProjectsProjectIdIndexRoute: typeof OrgsOrgSlugProjectsProjectIdIndexRoute
  OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute: typeof OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute
  OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute: typeof OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute
  OrgsOrgSlugProjectsProjectIdShotsShotIdRoute: typeof OrgsOrgSlugProjectsProjectIdShotsShotIdRouteWithChildren
}

const OrgsOrgSlugProjectsProjectIdRouteChildren: OrgsOrgSlugProjectsProjectIdRouteChildren =
  {
    OrgsOrgSlugProjectsProjectIdComplianceRoute:
      OrgsOrgSlugProjectsProjectIdComplianceRoute,
    OrgsOrgSlugProjectsProjectIdDashboardRoute:
      OrgsOrgSlugProjectsProjectIdDashboardRoute,
    OrgsOrgSlugProjectsProjectIdPlaylistsRoute:
      OrgsOrgSlugProjectsProjectIdPlaylistsRoute,
    OrgsOrgSlugProjectsProjectIdReviewSessionsRoute:
      OrgsOrgSlugProjectsProjectIdReviewSessionsRouteWithChildren,
    OrgsOrgSlugProjectsProjectIdShareLinksRoute:
      OrgsOrgSlugProjectsProjectIdShareLinksRoute,
    OrgsOrgSlugProjectsProjectIdTimelineRoute:
      OrgsOrgSlugProjectsProjectIdTimelineRoute,
    OrgsOrgSlugProjectsProjectIdIndexRoute:
      OrgsOrgSlugProjectsProjectIdIndexRoute,
    OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute:
      OrgsOrgSlugProjectsProjectIdSettingsStatusesRoute,
    OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute:
      OrgsOrgSlugProjectsProjectIdSettingsTaskTypesRoute,
    OrgsOrgSlugProjectsProjectIdShotsShotIdRoute:
      OrgsOrgSlugProjectsProjectIdShotsShotIdRouteWithChildren,
  }

const OrgsOrgSlugProjectsProjectIdRouteWithChildren =
  OrgsOrgSlugProjectsProjectIdRoute._addFileChildren(
    OrgsOrgSlugProjectsProjectIdRouteChildren,
  )

interface OrgsOrgSlugRouteChildren {
  OrgsOrgSlugIndexRoute: typeof OrgsOrgSlugIndexRoute
  OrgsOrgSlugAdminInvitesRoute: typeof OrgsOrgSlugAdminInvitesRoute
  OrgsOrgSlugAdminMembersRoute: typeof OrgsOrgSlugAdminMembersRoute
  OrgsOrgSlugAdminProjectsRoute: typeof OrgsOrgSlugAdminProjectsRoute
  OrgsOrgSlugProjectsProjectIdRoute: typeof OrgsOrgSlugProjectsProjectIdRouteWithChildren
}

const OrgsOrgSlugRouteChildren: OrgsOrgSlugRouteChildren = {
  OrgsOrgSlugIndexRoute: OrgsOrgSlugIndexRoute,
  OrgsOrgSlugAdminInvitesRoute: OrgsOrgSlugAdminInvitesRoute,
  OrgsOrgSlugAdminMembersRoute: OrgsOrgSlugAdminMembersRoute,
  OrgsOrgSlugAdminProjectsRoute: OrgsOrgSlugAdminProjectsRoute,
  OrgsOrgSlugProjectsProjectIdRoute:
    OrgsOrgSlugProjectsProjectIdRouteWithChildren,
}

const OrgsOrgSlugRouteWithChildren = OrgsOrgSlugRoute._addFileChildren(
  OrgsOrgSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  OrgsOrgSlugRoute: OrgsOrgSlugRouteWithChildren,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsThemeRoute: SettingsThemeRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
